import CollectionAdmin from "./CollectionAdmin";

export default function AppointmentInfoAdmin() {
  return (
    <CollectionAdmin
      title="Timeinfo"
      basePath="/api/admin/appointment-info"
      fields={[
        { key: "title", label: "Tittel", required: true },
        { key: "description", label: "Beskrivelse", type: "multiline", required: true },
      ]}
    />
  );
}
